import React, { useState } from "react";
import { Container, Tabs, Tab, Box, Typography } from "@mui/material";
import Inbox from "../sections/Email/Inbox";
import EmailSender from "../sections/Email/EmailSender";
import Drafts from "../sections/Email/Drafts";
import Page from "../components/Page";

// TabPanel Component
function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default function Email() {
  const [tabValue, setTabValue] = useState(0);
  const [draftToEdit, setDraftToEdit] = useState(null);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue === 1) {
      setDraftToEdit(null); // Clear draft when switching to compose tab
    }
  };

  return (
    <Page title="Email">
      <Container>
        <Tabs
          value={tabValue}
          onChange={handleChange}
          textColor="primary"
          indicatorColor="primary"
        >
          <Tab label="Inbox" />
          <Tab label="Compose" />
          <Tab label="Drafts" />
        </Tabs>

        <TabPanel value={tabValue} index={0}>
          <Inbox setDraftToEdit={(draft) => {
            setDraftToEdit(draft);
            setTabValue(1); // Switch to Compose tab
          }} />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <EmailSender draft={draftToEdit} />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <Drafts setDraftToEdit={(draft) => {
            setDraftToEdit(draft);
            setTabValue(1); // Switch to Compose tab
          }} />
        </TabPanel>
      </Container>
    </Page>
  );
}
